import { Enums } from "../common"

import { IJsonSerializable } from "../util/interfaces"
import { TypeHelper } from "../../helpers";

export class ErrorCode implements IJsonSerializable {

    // Properties

    public systemVersion: string
    public module: Enums.Module
    public source: string
    public moduleId: number
    public eventId: number

    // Properties End


    // Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    // Ctor End


    public toString(): string {
        if (this.systemVersion != null && this.module != null && this.moduleId != null && this.eventId != null) {
            return `FC (${TypeHelper.padStart(this.systemVersion, 2, '0')}-${TypeHelper.padStart(this.module.toString(), 3, '0')}-${this.source}-${TypeHelper.padStart(this.moduleId.toString(), 3, '0')}-${TypeHelper.padStart(this.eventId.toString(16).toUpperCase(), 6, '0')})`
        }

        return TypeHelper.emptyString
    }


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.systemVersion = opObj.SystemVersion
            this.module = opObj.Module
            this.source = opObj.Source
            this.moduleId = opObj.ModuleId
            this.eventId = opObj.EventId
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            SystemVersion: this.systemVersion,
            Module: this.module,
            Source: this.source,
            ModuleId: this.moduleId,
            EventId: this.eventId
        }
    }

    // IJsonSerializable Implementation End
}